import { QueryRenderer, useRelayEnvironment } from 'react-relay';
import type { QueryRendererProps } from 'react-relay';
import type { CacheConfig, FetchPolicy, OperationType } from 'relay-runtime';

export default function QueryWithCacheRenderer<
    TOperation extends OperationType,
>({
    query,
    variables,
    render,
    environment,
    fetchPolicy = 'store-or-network',
}: {
    cacheConfig?: CacheConfig | null | undefined;
    fetchPolicy?: FetchPolicy | undefined;
    environment?: QueryRendererProps<TOperation>['environment'];
} & Omit<QueryRendererProps<TOperation>, 'environment'>) {
    const relayEnvironment = useRelayEnvironment();
    return (
        <QueryRenderer
            fetchPolicy={fetchPolicy}
            environment={environment ?? relayEnvironment}
            query={query}
            render={render}
            variables={variables}
        />
    );
}
